
<template>
  <v-btn v-on:click="executeExport">{{ this.$t("ctrl.export") }}</v-btn>
</template>

<script>
import {
    VBtn
} from 'vuetify/lib'

export default {
  name: "Exporter",
  data: () => ({}),
  props: {
    data: Array,
    headers: Array,
    filename: String
  },
  methods: {
    executeExport: function() {
      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(this.getCsv());
      this.downloadURI(uri, this.filename);
    },
    getCsv: function () {
      Object.byString = function (o, s) {
        s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
        s = s.replace(/^\./, ""); // strip a leading dot
        var a = s.split(".");
        for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i];
          if (o && k in o) {
            o = o[k];
          } else {
            return;
          }
        }
        return o;
      };

      let csvContent = "";
      for (var i = 0; i < this.headers.length; i++) {
        csvContent += this.headers[i].text + ",";
      }
      csvContent += "\r\n";
      for (var j = 0; j < this.data.length; j++) {
        for (var i = 0; i < this.headers.length; i++) {
          var value = Object.byString(this.data[j], this.headers[i].value);
          csvContent += '"' + value + '",';
        }
        csvContent += "\r\n";
      }
      return csvContent;
    },
    downloadURI: function (uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  computed: {},
  components: {
    VBtn
  },
  mounted() {},
  filters: {},
}
</script>